/**
 * Format a byte count as a human-readable size string.
 * - 0–1023 bytes: "X B"
 * - 1024+ bytes: "X.X KB"
 * - 1048576+ bytes: "X.X MB"
 * One decimal place from KB up.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
